<template>
  <div style="background: #ffffff;border-radius: 8px;padding: 12px 24px 24px 24px">
    <div class="fontSize20gay text-left">每周设备巡检</div>
    <div style="border-bottom: 1px solid #EBEBEB;border-top: 1px solid #EBEBEB;margin-top: 16px;padding: 36px 0">
      <div style="width: 800px;margin: auto">
        <el-form :model="pageForm" :rules="pageFormRules" ref="formRef">
          <el-form-item label="日期" prop="date" size="large" label-width="160px">
            <el-date-picker v-model="pageForm.date"
                            type="date"
                            size="large"
                            placeholder="请选择日期"
                            value-format="YYYY-MM-DD"/>
          </el-form-item>
          <el-form-item label="周次" prop="week" size="large" label-width="160px">
            <el-input type="text"
                      v-model="pageForm.week"
                      maxlength="5"
                      @blur="integerParse(pageForm.week, val => pageForm.week = val)"></el-input>
          </el-form-item>
          <el-form-item label="实验室" prop="laboratoryId" size="large" label-width="160px">
            <el-select v-model="pageForm.laboratoryId"
                       filterable
                       class="room-select-tl"
                       placeholder="选择实验室"
                       size="large">
              <el-option v-for="item in laboratoryList"
                         :key="item.id"
                         :label="item.name"
                         :value="item.id"
              />
            </el-select>
          </el-form-item>

          <el-form-item label="设备名称" prop="equipmentName" size="large" label-width="160px">
            <el-input type="text" v-model="pageForm.equipmentName"></el-input>
          </el-form-item>
          <el-form-item label="巡查仪器状态" prop="xcyState" size="large" label-width="160px">
            <el-input type="text" v-model="pageForm.xcyState"></el-input>
          </el-form-item>
          <el-form-item label="巡查仪器检查结果" prop="xcyResult" size="large" label-width="160px">
            <el-input type="text" v-model="pageForm.xcyResult"></el-input>
          </el-form-item>

          <el-form-item label="巡检员" prop="userId" size="large" label-width="160px">
            <el-select v-model="pageForm.userId"
                       filterable
                       class="room-select-tl"
                       placeholder="搜索巡检员"
                       size="large"
                       remote
                       :remote-method="getUserList"
                       @change="selectChange">
              <el-option v-for="item in teacherList"
                         :key="item.id"
                         :label="item.name"
                         :value="item.id"
              />
              <template #prefix>
                <div>
                  {{ teacher.code }}
                </div>
              </template>
            </el-select>
          </el-form-item>
          <el-form-item label="现场照片" prop="image" size="large" label-width="160px">
            <image-list ref="imageList"></image-list>
          </el-form-item>
          <el-form-item label="备注" prop="notes" size="large" label-width="160px">
            <el-input v-model="pageForm.notes"
                      :autosize="{ minRows: 2, maxRows: 4 }"
                      type="textarea"
            />
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="marginTop15px">
      <button class="subBtn" @click="subData">保存</button>
      <button class="qxBtn" @click="qxBtn">取消</button>
    </div>
  </div>
</template>

<script>
import {getAllLaboratory, getTeacherList, setEquipment} from "@/api/examination";
import {integerParse} from "@/utils/common";
import ImageList from "@/view/patrolInspection/ImageList";

export default {
  name: "laboratoryEquipment",
  components: {ImageList},
  data(){
    return {
      teacherList: [],
      teacher: {},
      laboratoryList: [],
      pageForm: {
        // 周次
        week: '',
        // 日期
        date: '',
        // 实验室名称
        laboratoryId: '',
        // 设备名称
        equipmentName: '',
        // 巡查仪器状态
        xcyState: '',
        // 巡查仪器检查结果
        xcyResult: '',
        // 巡检人员
        userId: '',
        // 备注
        notes: '',
      },
      pageFormRules: {
        date: [
          { required: true, message: '请选择日期', trigger: 'blur' },
        ],
        laboratoryId: [
          { required: true, message: '请选择实验室', trigger: 'blur' },
        ],
        userId: [
          { required: true, message: '请选择巡检员', trigger: 'blur' },
        ],
        // 周次
        week: [
          { required: true, message: '请填写周次', trigger: 'blur' },
          // {
          //   validator: (rule, value, cb) => {
          //     if (value.length <= 26) {
          //       if (value.length === 1 && !value[0].title) {
          //         callback(new Error('请至少填写一个选项'))
          //         return
          //       }
          //       callback()
          //     } else {
          //       callback(new Error('最多只支持26个选项'))
          //     }
          //   }
          // }
        ],
        // 设备名称
        equipmentName: [
          { required: true, message: '请填写设备名称', trigger: 'blur' },
        ],
        // 巡查仪器状态
        xcyState: [
          { required: true, message: '请填写巡查仪器状态', trigger: 'blur' },
        ],
        // 巡查仪器检查结果
        xcyResult: [
          { required: true, message: '请填写巡查仪器检查结果', trigger: 'blur' },
        ],
      },
      id: null,
    }
  },
  mounted() {
    this.init();
    let data=this.$root.useRoute.query;
    if(data.info){
      this.pageForm=JSON.parse(data.info);
      this.$refs.imageList.setImageInfo(this.pageForm.img);
      if(this.pageForm && this.pageForm.teacher) {
        this.getUserList(this.pageForm.teacher.name);
      }
    }
  },
  methods: {
    integerParse,
    selectChange(e){
      this.teacher = this.teacherList.find(iter => iter.id == e) || {}
    },
    init(){
      getAllLaboratory().then(res => {
        if (res.success) {
          this.laboratoryList = res.data
        } else {
          this.$root.ElMessage.error(res.message)
        }
      })
    },
    getUserList(keyword){
      if (keyword) {
        getTeacherList({ name: keyword }).then(res => {
          if (res.success) {
            this.teacherList = res.data
          } else {
            this.$root.ElMessage.error(res.message)
          }
        })
      }
    },
    getTeachers(){

    },
    subData(){
      this.$refs.formRef.validate((valid, error) => {
        if (valid) {
          const handler = setEquipment
          let method='post';
          if(this.pageForm.id){method='put'}
          handler({ ...this.pageForm, img: this.$refs.imageList.getImg() },method).then(res => {
            if(res.success){
              this.$root.ElMessage({type:'success',message:res.message});
              setTimeout(() => {
                this.$root.useRouter.replace('/patrolInspection/equipmentWeekList')
              }, 500)
            }else{
              this.$root.ElMessage.error(res.message);
            }
          })
        } else {
          const key = Object.keys(error)[0]
          const msg = error[key][0].message
          this.$root.ElMessage.error(msg)
        }
      })
    },
    qxBtn(){
      this.$root.useRouter.go(-1);
    },
  }
}
</script>

<style lang="scss" scoped>

</style>